import { render, staticRenderFns } from "./ReportItemList.vue?vue&type=template&id=05643337"
import script from "./ReportItemList.vue?vue&type=script&lang=js"
export * from "./ReportItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports